/** Merchant industry is free text ("Construction", "CONSTRUCTION ", …) —
 * compare on lowercase alphanumerics only. */
export function normalizeIndustry(raw: string | null | undefined): string {
  return (raw ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** Returns the matching prohibited entry when the merchant's (normalized)
 * industry hits the funder's comma-separated prohibited list, else null.
 * Mirrors the guard in the submission-email edge function. */
export function industryBlocked(prohibitedRaw: string | null | undefined, merchantIndustry: string): string | null {
  if (!merchantIndustry) return null;
  for (const entry of (prohibitedRaw ?? '').split(/[,;]+/)) {
    const norm = normalizeIndustry(entry);
    if (norm && merchantIndustry.includes(norm)) return entry.trim();
  }
  return null;
}
